import { render } from "./ModelDelete.vue?vue&type=template&id=20503f06"
import script from "./ModelDelete.vue?vue&type=script&lang=js"
export * from "./ModelDelete.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__